module.exports = __webpack_public_path__ + "static/media/test13_2.5542b1c1.png";